import bannersForm from "@/components/banners/banners-form-template"
import form from "@/components/banners/default-form-props.js"
import { mapActions } from "vuex"
export default {
  components: {
    bannersForm
  },

  data() {
    return {
      form: { ...form },
      pending: false,
      loading: false,
      tabs: {
        // eslint-disable-next-line no-undef
        lang_prefix: $langPrefix
      }
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    ...mapActions("banners", ["submit", "detail", "delete"]),
    handleImage(e) {
      if (e != 0) {
        this.form[`image_file_${this.tabs.lang_prefix}`] = e[0].fileTarget
      }
    },

    async fetchData() {
      if (!this.$route.params.id) {
        return false
      }

      this.loading = true

      try {
        const data = await this.detail(this.$route.params.id)
        if (data) {
          this.form = data
        }
      } catch (err) {
        console.log(err)
        this.loading = false
      }
      this.loading = false
    },

    async submitForm() {
      if (!this.form.link) {
        this.$message.error("Введите ссылку для баннера")
        return
      }

      if (
        ["uz", "oz", "ru", "en", "tj", "kz"].some(
          (item) => !this.form[`image_file_${item}`]
        )
      ) {
        this.$message.error("Выберите фото баннера на всех языках")
        return
      }

      this.pending = true
      await this.submit(this.form)
      this.pending = false

      this.$router.go(-1)
    },

    async deleteAction() {
      this.pending = true
      try {
        await this.delete(this.form.id)
        this.$message.success("Успешно удалено")
      } catch (error) {
        console.error(error)
      }
      this.pending = false
      this.$router.go(-1)
    }
  }
}
